import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Grid from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import { connect } from 'react-redux';
import _clonedeep from 'lodash/cloneDeep';
import properties from '../../../modules/ajio-util/properties';
import Modal from '../../common/Modal';
import { eraseCookie, readCookie } from '../../common/Cookie';
import { signInCheck } from '../../common/CheckUserStatus';
import { storageAvailable } from '../../common/storageAvailable';
import { clearLocalStorage, clearCookie } from '../../../utils/clearStorage';
import { generateEvent } from '../../../utils/dataGrinch';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { showModal, hideModal } from '../../../actions/modal.js';
import PersonalInfo from '../../../../src/myaccount/components/desktop/PersonalInfo';
import { setLayoutModalContent, removeLayoutModalContent } from '../../../actions/webMetaData';
import SeoDropdown from '../../common/SeoDropdown';
import { getRuntimeBannersFlag, getRuntimeBannersSisFlag } from '../../../Flags/selectors.js';
import { makeValidUrl } from '../header/Navigation-runtime/utils';

import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getLuxePageInfo } from '../../../utils/pageInfo';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import {
  getLuxeBottomIconStripUrl,
  getAccountDeletionFlag,
  getAccountDeletionFeatureConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

function renderRuntimeFooter(footerdata, target, linkClick, newDesignLuxe,yourDataRef) {
  return footerdata.childDetails.map((item, i) => {
    return (
      <section className="ftr-support" key={i}>
        <div className="headline" aria-label={item.name} role='heading' aria-level={2}>
          <strong>{item.name}</strong>
        </div>
        <ul className="ftr-items">
          {item.childDetails.map((link, j) => {
            let url = link.fullUrl ? link.fullUrl : link.url;
            if (link.isVisible != false) {
              if (link.url == '/home' || link.url == '/') {
                return (
                  <li><a
                    key={j}
                    onClick={e => {
                      if (storageAvailable('localStorage')) {
                        clearLocalStorage([
                          'categoryClicked',
                          'categoryType',
                          'categoryPath',
                          'coreSelectedOn'
                        ]);
                      }
                      clearCookie([
                        'categoryClicked',
                        'categoryType',
                        'categoryPath',
                        'coreSelectedOn'
                      ]);
                      linkClick(
                        `${properties.getProperty('parentUrl')}`,
                        link.name,
                        '',
                        newDesignLuxe
                      );
                    }}
                    href={`${properties.getProperty('parentUrl')}/home`}
                    title={link.name}
                    aria-label={link.name}
                  >
                    {link.name}
                  </a></li>
                );
              } else {
                if (
                  link.name == 'Facebook' ||
                  link.name == 'Instagram' ||
                  link.name == 'Twitter' ||
                  link.name == 'Pinterest'
                ) {
                  return (
                    <li><a
                      href={url}
                      onClick={() => {
                        linkClick(url, link.name, '', newDesignLuxe);
                      }}
                      key={j}
                      title={link.name}
                      target="_blank"
                      aria-label={link.name}
                    >
                      {link.name}
                    </a></li>
                  );
                } else if (link.url == '/your-data') {
                  return (
                    <li>
                      <a
                        ref={yourDataRef}
                        href={url}
                        onClick={e => {
                          e.preventDefault();
                          linkClick(url, link.name, '', newDesignLuxe);
                        }}
                        key={j}
                        title={link.name}
                        aria-label={link.name}
                      >
                        {link.name}
                      </a>
                    </li>

                  );
                } else {
                  return (
                    <li><a
                      href={makeValidUrl(url)}
                      target={target}
                      onClick={() => {
                        linkClick(url, link.name, '', newDesignLuxe);
                      }}
                      key={j}
                      title={link.name}
                      aria-label={link.name}
                    >
                      {link.name}
                    </a></li>
                  );
                }
              }
            }
          })}
        </ul>
      </section>
    );
  });
}

function renderFooter(footerdata, target, linkClick, newDesignLuxe) {
  return footerdata.childDetails.map((item, i) => {
    return (
      <section className="ftr-support" key={i} tabIndex={0}>
        <div className="headline" tabIndex={0}>
          <strong>{item.name}</strong>
        </div>
        <ul className="ftr-items">
          {item.linkDetails.map((link, j) => {
            let url = link.fullUrl ? link.fullUrl : link.url;
            if (link.isVisible != false) {
              if (link.url == '/home' || link.url == '/') {
                return (
                  <li><a
                    key={j}
                    onClick={e => {
                      if (storageAvailable('localStorage')) {
                        clearLocalStorage([
                          'categoryClicked',
                          'categoryType',
                          'categoryPath',
                          'coreSelectedOn'
                        ]);
                      }
                      clearCookie([
                        'categoryClicked',
                        'categoryType',
                        'categoryPath',
                        'coreSelectedOn'
                      ]);
                      linkClick(
                        `${properties.getProperty('parentUrl')}`,
                        link.linkName,
                        '',
                        newDesignLuxe
                      );
                    }}
                    href={`${properties.getProperty('parentUrl')}/home`}
                    title={link.linkName}
                    aria-label={link.linkName}
                  >
                    {link.linkName}
                  </a></li>
                );
              } else {
                if (
                  link.linkName == 'Facebook' ||
                  link.linkName == 'Instagram' ||
                  link.linkName == 'Twitter' ||
                  link.linkName == 'Pinterest'
                ) {
                  return (
                    <li><a
                      href={url}
                      onClick={() => {
                        linkClick(url, link.linkName, newDesignLuxe);
                      }}
                      key={j}
                      title={link.linkName}
                      target="_blank"
                      aria-label={link.linkName}
                    >
                      {link.linkName}
                    </a></li>
                  );
                } else if (link.url == '/your-data') {
                  return (
                    <li><a
                      onClick={() => {
                        linkClick(url, link.linkName, '', newDesignLuxe);
                      }}
                      key={j}
                      title={link.linkName}
                      aria-label={link.linkName}
                    >
                      {link.linkName}
                    </a></li>
                  );
                } else {
                  return (
                    <li><a
                      href={url}
                      target={target}
                      onClick={() => {
                        linkClick(url, link.linkName, '', newDesignLuxe);
                      }}
                      key={j}
                      title={link.linkName}
                      aria-label={link.linkName}
                    >
                      {link.linkName}
                    </a></li>
                  );
                }
              }
            }
          })}
        </ul>
      </section>
    );
  });
}

class Footer extends React.Component {
  constructor() {
    super();
    this.state = {
      showOTPVerifyModal: false
    };
    this.yourDataRef = React.createRef();
  }

  linkClick(link, name, type = 'FooterClick', newDesignLuxe) {
    const { pageType = '' } = getLuxePageInfo(window.location.href);
    const { screenName = '', screenType = '' } = luxeScreen[pageType] || {};
    
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'footer_navigation_click',
        event_category: 'user interactions',
        event_action: 'footer navigation click',
        event_label: name,
        store_type: 'luxe',
        page_name: screenName,
        page_type: screenType 
      });
    } else {
      generateEvent({
        Event: this.getEventType(link),
        value: {
          LinkName: name,
          LinkUrl: link,
          Screen: 'Desktop'
        }
      });
    }
    if (link === '/your-data') {
      gtmEventPush({
        page_name: screenName,
        page_type: screenName,
        event: 'Page_Interaction',
        event_category: 'Page Interaction',
        event_action: 'footer link click',
        event_label: 'your data'
      });
      this.props.showModal('your-data');
      gtmEventPush({ 
        page_name: 'your data screen',
        page_type: 'your data screen',
        event: 'page_view'
      });
    }
  }

  getEventType(link) {
    if (
      link.includes('/shop/') ||
      link.includes('/s/') ||
      link.includes('/capsule/') ||
      link.includes('/help/BrandListing/')
    ) {
      return 'BottomNavClick';
    } else {
      return 'FooterClick';
    }
  }

  render() {
    const {
      footer: footerdata = {},
      overrideFooterSeoContent = '',
      runtimeBanners,
      runtimeBannersSis,
      isRuntimeBannerPage,
      isStore,
      hidePromiseIconsRowInFooter = false,
      newDesignLuxe,
      showModal,
      hideModal,
      isAccountDeletionEnabled,
      accountDeletionFeatureConfig,
      luxeBottomIconStripUrl = 'https://assets-jiocdn.ajio.com/cms/GAP/WEB/Icon%20Strip-Desktop.jpg' //firebase driven
    } = this.props;

    const isloggedIn = Boolean(signInCheck());
    let { childDetails = [] } = footerdata;
    let updatedFooterData = _clonedeep(footerdata);
    let updatedChildDetails = _clonedeep(childDetails);

    if (isloggedIn && isAccountDeletionEnabled) {
      updatedChildDetails = updatedChildDetails.map(headlineItem => {
        if (headlineItem?.sequence === 0) {
          const yourDataProps = {
            name: 'Your Data',
            newFlag: true,
            activeImageUrl: 'string',
            inactiveImageUrl: 'string',
            sequence: headlineItem?.childDetails.length,
            linkName: 'string',
            pageType: 'landingpage',
            url: '/your-data',
            query: 'string',
            tag: '',
            childDetails: [],
            channels: [
              {
                channelName: 'DESKTOP',
                defaultExpandable: true,
                visible: true
              },
              {
                channelName: 'KIOSK',
                defaultExpandable: false,
                visible: false
              }
            ],
            alternateUrl: 'stringhello<script>alert(0)</script>',
            userGroup: ['PREMIUM', 'NONPREMIUM', 'ECONOMY'],
            userSubGroup: [],
            inactiveAltText: ''
          };
          headlineItem?.childDetails.push(yourDataProps);
        }
        return headlineItem;
      });
      updatedFooterData = { ...updatedFooterData, childDetails: updatedChildDetails };
    }

    const target = '_self';
    if (Object.keys(updatedFooterData).length === 0 || updatedChildDetails.length == 0) {
      return null;
    }

    const footer =
      (isStore && runtimeBannersSis === 'ON') || (!isStore && runtimeBanners === 'ON')
        ? renderRuntimeFooter(updatedFooterData, target, this.linkClick.bind(this), newDesignLuxe,this.yourDataRef)
        : renderFooter(updatedFooterData, target, this.linkClick.bind(this), newDesignLuxe);

    const {
      youDataHeader = '',
      yourDataContent = '',
      accountDeletionHeader = '',
      accountDeletionContent = ''
    } = accountDeletionFeatureConfig;

    return (
      <div className={`${newDesignLuxe ? 'luxe-newDesign' : ' '}  main-footer`}>
        <footer>
          {!hidePromiseIconsRowInFooter && (
            <div className="ftr-top">
              {!newDesignLuxe ? (
                <ul>
                  <li>
                    <span className={newDesignLuxe ? 'd-block' : 'ic-update'} aria-hidden={true}>
                      {newDesignLuxe ? (
                        <img
                          src={`${properties.getProperty(
                            'imageBaseUrl'
                          )}/static/img/easy_exchange.png`}
                          alt=""
                        />
                      ) : (
                        ''
                      )}
                    </span>
                    <span aria-label="EASY EXCHANGE">
                      <strong>EASY EXCHANGE</strong>
                    </span>
                  </li>
                  <li>
                    <span className={newDesignLuxe ? 'd-block' : 'ic-pikup'} aria-hidden={true}>
                      {newDesignLuxe ? (
                        <img
                          src={`${properties.getProperty(
                            'imageBaseUrl'
                          )}/static/img/hand_picked.png`}
                          alt=""
                        />
                      ) : (
                        ''
                      )}
                    </span>
                    <span aria-label="100% HANDPICKED">
                      <strong>100% HANDPICKED</strong>
                    </span>
                  </li>
                  <li>
                    <span className={newDesignLuxe ? 'd-block' : 'ic-qlty'} aria-hidden={true}>
                      {newDesignLuxe ? (
                        <img
                          src={`${properties.getProperty(
                            'imageBaseUrl'
                          )}/static/img/assured_quality.png`}
                          alt=""
                        />
                      ) : (
                        ''
                      )}
                    </span>
                    <span aria-label="ASSURED QUALITY">
                      <strong>ASSURED QUALITY</strong>
                    </span>
                  </li>
                </ul>
              ) : (
                // <img src={luxeBottomIconStripUrl?.length > 0 ?  luxeBottomIconStripUrl : 'https://assets.ajio.com/cms/GAP/WEB/Icon%20Strip-Desktop.jpg'} className="luxe-exchange-desktop-img" />
                <div
                  style={{
                    backgroundImage: `url(${replaceWithJioCDN(luxeBottomIconStripUrl)}` + `)`
                  }}
                  className="luxe-exchange-desktop-img"
                  aria-label="Trustmarker banner"
                  role="img"
                />
              )}
            </div>
          )}

          <div className="ftr-cont">
            <div className="ftr-body">
              <div className="ftr-bodyinner">
                <SeoDropdown overrideFooterSeoContent={overrideFooterSeoContent} />
                {footer}
              </div>
              <div className="ftr-btm">
                <div className="ftr-payment">
                  <div className="headline" aria-label="Payment Methods" role='heading' aria-level={2}>
                    <strong>Payment Methods</strong>
                  </div>
                  <div className="method-list">
                    <ul>
                      <li aria-label="Net banking">
                        <span className="ic-netbank" />
                      </li>
                      <li aria-label="Visa">
                        <span className="ic-visa" />
                      </li>
                      <li aria-label="Master card">
                        <span className="ic-mastercard" />
                      </li>
                      <li aria-label="Amex">
                        <span className="ic-amex" />
                      </li>
                      <li aria-label="Cash on delivery">
                        <span className="ic-cod" />
                      </li>
                      <li aria-label="Jio money">
                        <span className="ic-jiomoney" />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="ftr-ss">
                  <div className="headline" aria-label="Secure Systems" role='heading' aria-level={2}>
                    <strong>Secure Systems</strong>
                  </div>
                  <div className="method-list">
                    <ul>
                      <li aria-label="SSL">
                        <span className="ic-ssl" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <Modal
          name="your-data"
          className={`your-data`}
          id="your-data-modal"
          closeButton={true}
          onClose={() => {
            hideModal('your-data');
            if (this.yourDataRef.current) {
               this.yourDataRef.current.focus();
            }
            gtmEventPush({
              page_name: 'your data screen',
              page_type: 'your data screen',
              event: 'my_account_interactions',
              event_category: 'my account interactions',
              event_action: 'close'
            });
          }}
        >
          <div className="your-data-container">
            <div className="your-data-container__header" role='heading' aria-level={2}>{youDataHeader}</div>
            <div className="your-data-container__content">{yourDataContent}</div>
            <div
              tabIndex={0}
              role="button"
              className="your-data-container__submit"
              onClick={() => {
                hideModal('your-data');
                gtmEventPush({
                  page_name: 'your data screen',
                  page_type: 'your data screen',
                  event: 'my_account_interactions',
                  event_category: 'my account interactions',
                  event_action: 'delete account'
                });
                this.setState(
                  {
                    showOTPVerifyModal: true
                  },
                  () => {
                    showModal('otp-popup');
                    gtmEventPush({ 
                      page_name: 'delete account opt half card',
                      page_type: 'delete account opt half card',
                      event: 'page_view'
                    });
                    segmentEventPush({
                      screen_name: 'Privacy Screen your data tab',
                      page_name: 'Privacy Screen your data tab',
                      // page_type: 'Privacy Screen your data tab',
                      event: 'Delete account half card viewed'
                    });
                  });
                }}
            >
              DELETE ACCOUNT
            </div>
          </div>
        </Modal>
        <Modal
          name="account-deletion-request"
          className={`account-deletion-request`}
          id="account-deletion-modal"
          closeButton={true}
          onClose={() => {
            gtmEventPush({
              page_name: 'account deletion request submitted page',
              page_type: 'account deletion request submitted page',
              event: 'buttonTap',
              event_category: 'delete profile interaction',
              event_action: 'close'
            });

            

            window.location = '/';
          }}
        >
          <div className="account-deletion-container">
            <div className="account-deletion-container__header" role='heading' aria-level={2}>
              <strong>{accountDeletionHeader}</strong>
            </div>
            <div className="account-deletion-container__content">{accountDeletionContent}</div>
            <div
              className="account-deletion-container__submit"
              onClick={() => {
                gtmEventPush({
                  page_name: 'account deletion request submitted page',
                  page_type: 'account deletion request submitted page',
                  event: 'buttonTap',
                  event_category: 'delete profile interaction',
                  event_action: 'delete account done'
                });

               
                window.location = '/';
              }}
              tabIndex={0}
              role="button"
            >
              Done
            </div>
          </div>
        </Modal>
        {this.state.showOTPVerifyModal && (
          <PersonalInfo
            reqAccountDeletion={true}
            redirectOnClose={false}
            disableOutsideClick={false}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { footer, flags, bannerInfo = {}, metaData = {} } = state;

  const runtimeBanners = getRuntimeBannersFlag(flags);
  const runtimeBannersSis = getRuntimeBannersSisFlag(flags);
  const luxeBottomIconStripUrl = getLuxeBottomIconStripUrl(flags);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const isAccountDeletionEnabled = getAccountDeletionFlag(flags);
  const accountDeletionFeatureConfig = getAccountDeletionFeatureConfig(flags);

  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    footer:
      (metaData.sis && runtimeBannersSis === 'ON') || (!metaData.sis && runtimeBanners === 'ON')
        ? footer.data
        : footer,
    runtimeBanners,
    runtimeBannersSis,
    isStore: metaData.sis,
    isRuntimeBannerPage: bannerInfo.isRuntimeBannerPage,
    luxeBottomIconStripUrl,
    isAccountDeletionEnabled,
    accountDeletionFeatureConfig
  };
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setLayoutModalContent: (content, optional) => {
      dispatch(setLayoutModalContent(content, optional));
    },
    removeLayoutModalContent: () => {
      dispatch(removeLayoutModalContent());
    }
  };
};

export default Footer = connect(mapStateToProps, mapDispatchToProps)(Footer);
